import React, {Component} from 'react';

export default class FilterButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let filterInput = <input type="radio"
                                 id={"map-component-filter--" + this.props.value}
                                 name="map-component-filter"
                                 value={this.props.value}
                                 onChange={this.props.handleActiveButtonChange}
                                 defaultChecked={this.props.isDefaultChecked} />;

        let filterLabel = <label htmlFor={"map-component-filter--" + this.props.value}
                                 role="radio"
                                 tabIndex="0"
                                 className={"map-component__button map-component__button--" + this.props.value}>
                                {this.props.value}
                          </label>;

        return (
            <React.Fragment>
                {filterInput}
                {filterLabel}
            </React.Fragment>
        );
    }
}